export default "__VITE_ASSET__e179e1aa__"